const inspection = {
  inspection: "倉儲巡檢",
  draft: "草稿",
  pending: "進行中",
  resolved: "已完成",
  rejected: "已取消",
  plState: "請選擇巡檢單狀態",
  state: "狀態",
  number: "巡檢單號",
  createdAt: "創建時間",
  updatedAt: "操作時間",
  planAt: "計劃時間",
  finishedAt: "完成時間",
  remark: "備註",
  detail: "詳情",
  add: "添加",
  saveOk: "保存成功",
  saveErr: "保存失敗",
  del: "刪除",
  delOk: "刪除成功",
  delErr: "刪除失敗",
  cancel: "取消",
  cancelTip: "確定取消這個巡檢單嗎？",
  cancelOk: "取消成功",
  cancelErr: "取消失敗",
  notE: "不存在",
  exist: "存在",
  partE: "部分存在",
  notS: "不符合",
  suitable: "符合",
  partS: "部分符合",
  notInspect: "未檢",
  config: "巡檢配置",
  needInspection: "是否需要巡檢",
  cycleDays: "巡檢週期(天)",
  cycleDaysPlaceholder: "不填則為不定期/按需",
  content: "巡檢內容說明",
  yes: "是",
  no: "否",
  day: "天",
  plsSelectIns: "請選擇是否需要巡檢",
  finish: "完成",
  finishTip: "你確定完成該巡檢單嗎？",
  finishOk: "該巡檢單已完成",
  finishErr: "完成失敗",
  inspector: "巡檢員",
  locationCode: "庫位編碼",
  existenceState: "存在狀態",
  complianceState: "符合度",
  action: "處理措施",
  inspectedAt: "巡檢時間",
  addOrder: "添加巡檢單",
  plProduct: "請選擇要巡檢的物料",
  plPlanAt: "請選擇要巡檢時間",
  addProduct: "添加物料",
  redPro: "標紅物料無巡檢配置",
  inspectProgress: "巡檢進度",
  inspectItem: "巡檢項",
  attechment: "巡檢附件",
  submitInspect: "提交巡檢",
  submitSucc: "巡檢提交成功",
  submitFail: "巡檢提交失敗",
  inspect: "巡檢",
  specialHandlingAggregate: "存儲環境狀態",
  specialHandlingState: "存儲環境還原",
  specialHandlingRemark: "備註",
  notSx: "未按要求",
  suitablex: "按要求",
  partSx: "部分按要求",
  notInspectx: "無需處理",
  unFinish: "有巡檢項未巡檢，不可完成",
  orderCanceled: "該巡檢單已取消，巡檢保存失敗",
  orderFinished: "該巡檢單已完成，巡檢保存失敗",
  configExsist: "該要求類型已存在，無需添加",
};

export default inspection;
